import styled from 'styled-components';
const S = {};

const TabHeight = 3.5;

S.LiveEventListTreeContainer = styled.div`
    width: 100%;
    background-color: transparent;
    color: ${({theme: {$eventListTreeModalColor }}) => $eventListTreeModalColor};
`;

S.Header = styled.div`
    height: 4.5rem;
    text-align: center;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    position: relative; 
    &.categoryLevel0 {
        background-color: ${({theme: { $eventListTreeModalTabBackgroundColor }}) => $eventListTreeModalTabBackgroundColor};
    }
    &.categoryLevel1 {
        background-color: ${({theme: { $eventListTreeModalTabSportNameBackgroundColor }}) => $eventListTreeModalTabSportNameBackgroundColor};
        .back-btn,
        .close-btn {
            > svg {
                rect {
                    fill: ${({theme: { $eventListTreeModalCategoryLevel3BtnsHeaderBackgroundColor }}) => $eventListTreeModalCategoryLevel3BtnsHeaderBackgroundColor};
                }
            }
        }
    }

    &.categoryLevel0isPrematch,
    &.categoryLevel1isPrematch { 

        background-color: ${({ theme: { $eventListTreeModalTabCategoryNameBackgroundColor } }) => $eventListTreeModalTabCategoryNameBackgroundColor};
        .back-btn,
        .close-btn {
                > svg {
                    rect {
                        fill: ${({ theme: { $eventListTreeModalCategoryLevel3PrematchBtnsHeaderBackgroundColor } }) => $eventListTreeModalCategoryLevel3PrematchBtnsHeaderBackgroundColor};
                    }
                }
        }
    }

    display: flex;
`;

S.BackModalButton = styled.div`
    width: 34px;
    height: 34px;
    position: absolute;
    left: 5%;
    top: 1.3rem;
`;

S.CloseModalButton = styled.div`
    width: 34px;
    height: 34px;
    position: absolute;
    right: 5%;
    top: 1.3rem;
`;

S.RowTabContainer = styled.div`
    max-height: calc(${TabHeight}rem * 8 + 8px);
    overflow: hidden; 
    overflow-y: auto;
    background-color: ${({theme: {$eventListTreeModalEventDetailsBackgroundColor }}) => $eventListTreeModalEventDetailsBackgroundColor};
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    &::-webkit-scrollbar-thumb {
        background-color: ${({theme: { $eventListTreeModalScrollbarThumbBackgroundColor }}) => $eventListTreeModalScrollbarThumbBackgroundColor};
    }
    &::-webkit-scrollbar {
        width: 3px;
        height: 1rem;
    }
    &::-webkit-scrollbar-corner {
        background-color: ${({theme: { $eventListTreeModalScrollbarThumbBackgroundColor }}) => $eventListTreeModalScrollbarThumbBackgroundColor};
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
    }

`;

S.RowTab = styled.div`
    height: ${TabHeight}rem;
    line-height: ${TabHeight}rem;
    border-top: 1px solid ${({theme: {$eventListTreeModalBorderColor }}) => $eventListTreeModalBorderColor};
    display: flex;
    flex-direction: row;
    background-color: ${({theme: { $eventListTreeModalTabBackgroundColor }}) => $eventListTreeModalTabBackgroundColor};
    &:last-of-type {
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
    }
`;

S.EventsContainer = styled.div`
    display: none;
    &.open {
        display: block;
    }
`;

S.SportIcon = styled.img`
    height: 18px;
    width: 5%;
    margin: auto;
    margin-left: 5%;
`;

S.AllSportHeader = styled.div`
    margin: auto;
`;

S.SportIconHeader = styled.img`
    height: 25px;
    width: 25px;
    margin: auto;
    margin-right: 5px;
`;

S.SportNameHeader = styled.div`
    margin: auto;
    margin-left: 0px;
    padding-left: 10px;
    padding-right: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 58%;
    &.center {
        max-width: 70%;
        margin-left: auto;
    }
`;

S.RowTabText = styled.div`
    font-size: 14px;
    width: 72%;
    text-align: left;
    padding-left: 1rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &.iconHidden {
        padding-left: 0px;
        margin-left: 5%;
        width: 77%;
    }
`;

S.RowTabCountText = styled.div`
    font-size: 13px;
    width: 8%;
    text-align: right;
    padding-right: 8px;
`;

S.RowTabCountArrowContainer = styled.div`
    width: 5%;
    text-align: right;
    margin-right: 5%;
`;

S.SportCountArrow = styled.div`
    width: 6px;
    height: 6px;
    margin: auto;
    margin-right: 0px;
`;

S.CategoryCountArrow = styled.div`
    width: 15px;
    height: 6px;
    margin: auto;
    margin-right: 0px;
    
    &.open {
       > svg  {
            transform: rotate(180deg);
        }
    }
`;

S.CategoryRowTab = styled.div`
    height: ${TabHeight}rem;
    line-height: ${TabHeight}rem;
    border-top: 1px solid ${({theme: {$eventListTreeModalBorderColor }}) => $eventListTreeModalBorderColor};
    display: flex;
    flex-direction: row;
    background-color: ${({theme: { $eventListTreeModalCategoryTabBackgroundColor }}) => $eventListTreeModalCategoryTabBackgroundColor};
`

S.EventRowTab = styled.div`
    position: relative;
    width: 100%;
    height: 7rem;
    background-color: ${({theme: {$eventListTreeModalEventDetailsBackgroundColor }}) => $eventListTreeModalEventDetailsBackgroundColor};
    display: flex;
    flex-direction: row;
    font-size: 14px;

`;

S.EventPrematchRowTab = styled.div`
    position: relative;
    width: 100%;
    border-top: 1px solid ${({theme: {$eventListTreeModalEventDetailsPrematchBorderColor}}) => $eventListTreeModalEventDetailsPrematchBorderColor};
    background-color: ${({theme: {$eventListTreeModalEventDetailsPrematchBackgroundColor }}) => $eventListTreeModalEventDetailsPrematchBackgroundColor};
    display: flex;
    flex-direction: column;
    font-size: 14px;
    padding-top: 0.7rem;
    padding-bottom: 0.4rem;
`;

S.EventPrematchStartDateRow = styled.div`
    margin: auto;
    width: 100%;
    text-align: center;
    font-size: 13px;
    padding-bottom: 0.4rem;
`;

S.EventPrematchNameRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
`;

S.EventPrematchParticipantNameContainer = styled.div`
    width: 50%;
    display: flex;
    flex-direction: row;
    &.participant1 {
        justify-content: right;
    }
    &.participant2 {
        justify-content: left;
    }
`;

S.EventPrematchParticipantName = styled.div`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &.participant1 {
        padding-right: 1rem;
    }
    &.participant2 {
        padding-left: 0rem;
    }
`;

S.EventRowTabBottomBorder = styled.div`
    height: 1px;
    background-color: ${({theme: {$eventListTreeModalEventBorderBottomColor }}) => $eventListTreeModalEventBorderBottomColor};
    width: 90%; 
    margin-left: 5%;
    &:last-of-type {
        height: 0px;
    }
`;

S.MarkEventActive = styled.div`
    position: absolute;
    background-color: ${({theme: {$eventListTreeModalMarkActiveEventBackgroundColor }}) => $eventListTreeModalMarkActiveEventBackgroundColor};
    top: 2.5rem;
    height: 2rem;
    width: 4px;
`;

S.EventParticipantsColumn = styled.div`
    margin-left: 5%;
    width: 40%;
`;

S.EventParticipantNameContainer = styled.div`
    height: 50%;
    display: flex;
    &.participant1 {
        align-items: flex-end;
    }
    &.participant2 {
        align-items: flex-start;
    }
`;  

S.ParticipantIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 1rem;
    &.participant1 {
        padding-bottom: 0.5rem;
    }
    &.participant2 {
        padding-top: 0.5rem;
    }
    &.participant2.prematch {
        padding-top: 0rem;
        padding-bottom: 0.5rem;
    }
`;

S.ParticipantIcon = styled.img`
    height: 18px;
    width: 18px;
`

S.EventParticipantName = styled.div`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &.participant1 {
        padding-bottom: 0.5rem;
    }
    &.participant2 {
        padding-top: 0.5rem;
    }
`;

S.EventInfoColumn = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: right;
`;

S.EventMatchResultColumn = styled.div`
    width: 100%;
    margin-right: 5%;
    
`;

S.EventMatchResultParticipant1 = styled.div`
    height: 50%;
    display: flex;
    align-items: flex-end;
    justify-content: end;
`;

S.EventMatchResultParticipant2 = styled.div`
    height: 50%;
    display: flex;
    align-items: flex-start;
    justify-content: end;
`;

S.ParticipantScoresContainer = styled.ul`
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 0;
    justify-content: right;
    margin-block-start: 0em;
    margin-block-end: 0em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0px;
    &.p1 {
        margin-bottom: 0.5rem;
    }
    &.p2 {
        margin-top: 0.5rem;
    }
`;

S.ParticipantScore = styled.li`
    list-style: none;
    display: block;
    padding: 0;
    width: 18px;
    text-align: right;
    margin-right: 3px;
    &.set-result {
        color: ${({theme: {$eventListTreeModalSetResultColor }}) => $eventListTreeModalSetResultColor}; 
    }
    &:last-of-type {
        margin-right: 0px;;
    }
`;


export default S;